import { useForm } from "@tanstack/react-form";
import { createFileRoute } from "@tanstack/react-router";
import { Avatar, AvatarFallback, AvatarImage } from "~/components/ui/avatar";
import { Input } from "~/components/ui/input";
import { Label } from "~/components/ui/label";
import { SettingsProfileSkeleton } from "~/components/skeletons/profile-skeleton";
import { authClient } from "~/lib/auth-client";
import { m } from "~/i18n/messages";

export const Route = createFileRoute("/app/settings/profile")({
	component: ProfilePage,
});

function ProfilePage() {
	const { data: session, error, isPending } = authClient.useSession();

	const form = useForm({
		defaultValues: {
			name: session?.user.name,
			email: session?.user.email,
			avatar: session?.user.image,
			language: "en", // Default to 'en' as a fallback
		},
	});

	if (error) {
		return (
			<div className="p-8 text-red-500">
				Error loading profile: {error.message}
			</div>
		);
	}

	if (isPending) {
		return <SettingsProfileSkeleton />;
	}

	return (
		<form className="w-full h-full flex flex-col gap-4">
			<form.Field
				name="avatar"
				children={(field) => (
					<Avatar className="size-16 sm:size-20 mx-auto border">
						<AvatarImage
							src={field.state.value ?? ""}
							referrerPolicy="no-referrer"
						/>
						<AvatarFallback>
							{session?.user.name?.charAt(0) || "U"}
						</AvatarFallback>
					</Avatar>
				)}
			/>
			<form.Field
				name="email"
				children={(field) => (
					<div>
						<Label className="flex-col items-start">
							{m["settings.profile.email_label"]()}
							<Input
								className="bg-white"
								value={field.state.value}
								onBlur={field.handleBlur}
								onChange={(e) => field.handleChange(e.target.value)}
								readOnly
							/>
						</Label>
						<small className="text-xs sm:text-sm text-muted-foreground">
							{m["settings.profile.email_description"]()}
						</small>
					</div>
				)}
			/>
			<form.Field
				name="name"
				children={(field) => (
					<div>
						<Label className="flex-col items-start">
							{m["settings.profile.name_label"]()}
							<Input
								className="bg-white"
								value={field.state.value}
								onBlur={field.handleBlur}
								onChange={(e) => field.handleChange(e.target.value)}
							/>
						</Label>
						<small className="text-xs sm:text-sm text-muted-foreground">
							{m["settings.profile.name_description"]()}
						</small>
					</div>
				)}
			/>
		</form>
	);
}
